import styled from 'styled-components';
import SHDInput from '@ui/Input/SHDInput';

export const StyledSHDInput = styled(SHDInput)`
  & > div > div > div {
    border: none;
  }
`;
